import * as React from 'react'

import { PackageIcon, TableIcon } from 'lucide-react'
import { inject, observer } from 'mobx-react'
import { RouteComponentProps, withRouter } from 'react-router'

import ViewMode from '~/client/src/shared/components/ViewSelector/ViewMode'
import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'
import useMaterialResources from '~/client/src/shared/hooks/useMaterialResources'
import { useResourceRuntimeContext } from '~/client/src/shared/hooks/useResourceRuntimeContext'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { buildResourceUiConfig } from '~/client/src/shared/resources/builders/buildResourceUiConfig'

import { MobileResourceConfig } from '../../components/MobileResource'
import MobileResourceViewLayout from '../../components/MobileResource/MobileResourceViewLayout'
import MobileInitialState from '../../stores/MobileInitialState'
import MobileCommonStore from '../../stores/ui/MobileCommon.store'
import MobileMaterialResourcesEditPanel from './MobileMaterialResourcesEditPanel'

interface IProps {
  state?: MobileInitialState
  common?: MobileCommonStore
}

const MATERIALS_UI_DEFAULTS = buildResourceUiConfig(ResourceTypeId.MATERIALS)

// The title passes size="lg", a named token Lucide can't resolve.
const HeaderIcon: React.FC<{ className?: string }> = ({ className }) => (
  <PackageIcon size={28} className={className} />
)

const VIEW_MODES: ViewMode[] = [{ mode: 'list', Icon: TableIcon }]

const MobileMaterialResourcesView: React.FC<IProps & RouteComponentProps> = ({
  state,
  common,
}) => {
  const projectId = state?.activeProject?.id
  const runtimeContext = useResourceRuntimeContext()

  const resourceConfig = React.useMemo<MobileResourceConfig>(
    () => ({
      resourceTypeId: ResourceTypeId.MATERIALS,
      title: Localization.translator.materials,
      icon: HeaderIcon,
      useRecords: useMaterialResources,
      initialSortKey: MATERIALS_UI_DEFAULTS.defaultSortKey,
      initialSortOrder: MATERIALS_UI_DEFAULTS.defaultSortOrder,
      initialGroupByKey: MATERIALS_UI_DEFAULTS.defaultGroupingKey,
      countLabel: count => `${count} ${Localization.translator.materials}`,
      viewModes: VIEW_MODES,
      noneGroupByValue: MATERIALS_UI_DEFAULTS.noneGroupingKey,
      emptyMessage: Localization.translator.noDataAvailable,
      runtimeContext,
    }),
    [runtimeContext],
  )

  React.useEffect(() => {
    common.hideNavBar()
  }, [common])

  return (
    <MobileResourceViewLayout
      config={resourceConfig}
      state={state}
      projectId={projectId}
    >
      <MobileMaterialResourcesEditPanel />
    </MobileResourceViewLayout>
  )
}

export default withRouter(
  inject('state', 'common')(observer(MobileMaterialResourcesView)),
)
